import { formatPrice } from "@flicket/utils";
import { ReactNode } from "react";
import { Select } from "~components";
import { CurrentOrganizationQuery } from "~graphql/typed-document-nodes";
import { SmsOrderConfirmation } from "~hooks";

const getSmsConfirmationOptions = (
  organization: CurrentOrganizationQuery["currentOrganization"],
  smsConfirmation?: SmsOrderConfirmation
) => {
  return smsConfirmation
    ? [
        {
          value: "sms",
          label: `SMS - ${formatPrice(smsConfirmation.fee, {
            currency: organization.currency,
          })}`,
        },
        {
          value: "digital",
          label: `Email - ${formatPrice(0, {
            currency: organization.currency,
          })}`,
        },
      ]
    : [];
};

type DeliveryOptionsProps = {
  organization: CurrentOrganizationQuery["currentOrganization"];
  smsConfirmation?: SmsOrderConfirmation;
  label: ReactNode;
  value: "digital" | "sms";
  onChange: (value: "digital" | "sms") => void;
  disabled?: boolean;
};

export const DeliveryOptions = ({
  organization,
  smsConfirmation,
  label,
  onChange,
  value,
  disabled,
}: DeliveryOptionsProps) => {
  const smsConfirmationOptions = getSmsConfirmationOptions(
    organization,
    smsConfirmation
  );

  if (!smsConfirmation) {
    return null;
  }

  return (
    <Select
      label={label}
      value={
        smsConfirmationOptions.find((v) => v.value === value) ??
        smsConfirmationOptions[0]
      }
      onChange={onChange}
      options={smsConfirmationOptions}
      width={{ _: "100%" }}
      disabled={disabled}
    />
  );
};
